/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrerrorcorrectionh3Inputs */

const en_qrerrorcorrectionh3 = /** @type {(inputs: Qrerrorcorrectionh3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum`)
};

const de_qrerrorcorrectionh3 = /** @type {(inputs: Qrerrorcorrectionh3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal`)
};

/**
* | output |
* | --- |
* | "Maximum" |
*
* @param {Qrerrorcorrectionh3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrerrorcorrectionh3 = /** @type {((inputs?: Qrerrorcorrectionh3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrerrorcorrectionh3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrerrorcorrectionh3(inputs)
	return de_qrerrorcorrectionh3(inputs)
});
export { qrerrorcorrectionh3 as "qrErrorCorrectionH" }